/**
 * Resident Summary Cards Component
 *
 * Container component that renders 4 summary cards in a row:
 * - Total Residents
 * - High
 * - Medium
 * - Low
 */

import { Users, CircleAlert, Activity, CircleCheck } from "lucide-react";
import { ResidentSummaryCard } from "./ResidentSummaryCard";

interface ResidentSummaryCardsProps {
  totalCount: number;
  highRiskCount: number;
  mediumRiskCount: number;
  lowRiskCount: number;
}

export function ResidentSummaryCards({
  totalCount,
  highRiskCount,
  mediumRiskCount,
  lowRiskCount,
}: ResidentSummaryCardsProps) {
  const pct = (count: number) =>
    totalCount > 0 ? ((count / totalCount) * 100).toFixed(1) : "0.0";

  return (
    <div className="flex gap-4">
      <ResidentSummaryCard
        label="Total Residents"
        count={totalCount}
        icon={Users}
        backgroundColor="#F5F5F5"
        textColor="#1B3647"
        borderColor="#BBC3C8"
        footer="Active census"
      />
      <ResidentSummaryCard
        label="High"
        count={highRiskCount}
        icon={CircleAlert}
        backgroundColor="#FFFFFF"
        textColor="#1B3647"
        accentColor="#B02828"
        borderColor="#B02828"
        footer={`${pct(highRiskCount)}% of census`}
      />
      <ResidentSummaryCard
        label="Medium"
        count={mediumRiskCount}
        icon={Activity}
        backgroundColor="#FFFFFF"
        textColor="#1B3647"
        accentColor="#D97706"
        borderColor="#D97706"
        footer={`${pct(mediumRiskCount)}% of census`}
      />
      <ResidentSummaryCard
        label="Low"
        count={lowRiskCount}
        icon={CircleCheck}
        backgroundColor="#FFFFFF"
        textColor="#15803D"
        accentColor="#15803D"
        borderColor="#15803D"
        footer={`${pct(lowRiskCount)}% of census`}
      />
    </div>
  );
}
